import templateUrl from './edit-pay-stub-commissions.component.html'

export const EditPayStubCommissionsComponent = {
    templateUrl,
    bindings: {
        payStubEntry: "<"
    },
    controller: class EditPayStubCommissionsComponent {
    }
}
